module.exports = __webpack_public_path__ + "static/media/right_arrow_black.43cf999d.svg";